// Code review - In Progress
// Documentation - In Progress


import React from "react";
import PropTypes from "prop-types";
import { mainTable } from "../css/Common";

const RadioGroup = (props) => {
  
  const selectedOption = props.selectedOptions || '';
  const handleOptionChange = (value) => {
    props.controlFunc(value);
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Tab") {
      const radios = document.getElementsByName(props.setName);
  
      const isLast = index === radios.length - 1;
      const isFirst = index === 0;
  
      // SHIFT + TAB on first → allow previous field
      if (e.shiftKey && isFirst) return;
  
      // TAB on last → allow next field
      if (!e.shiftKey && isLast) return;
  
      // Otherwise stay inside group
      e.preventDefault();
  
      const nextIndex = e.shiftKey ? index - 1 : index + 1;
  
      if (radios[nextIndex]) {
        radios[nextIndex].focus();
      }
    }
  };
  return (
    <div className={props.classDiv || "form-group"}>
      <label className={props.classLabel ? props.classLabel : mainTable.label}>
        {props.title}
        <span className={props.classStar ? props.classStar : "hidden"}>*</span>
      </label>
      {/* <label className={props.ClassLabel || mainTable.label}>
        {props.title}
        <span className={props.classStar || "hidden"}>*</span>
      </label> */}
      <div className={props.Class1 || mainTable.inputRadioDiv}>
        {props.options.map((option, index) => (
          <label
            key={option.value}
            className={props.ClassLabel || mainTable.inputRadioLabel}
          >
            <input
              className={props.Class || mainTable.inputRadio}
              name={props.setName}
              onChange={() => handleOptionChange(option.value)}
              value={option.value}
              checked={selectedOption === option.value}
              type="radio"
              disabled={props.disabled}
              // tabIndex={props.tabIndex}
              tabIndex={0}
              onKeyDown={(e) => handleKeyDown(e, index)}
              onBlur={props.controlFuncBlur}
            />
            {option.label}
            
          </label>
        ))}
      </div>
      {props.errorMessage && (
              <span class="text-red-500">{props.errorMessage}</span>
            )}
    </div>
  );
};

RadioGroup.propTypes = {
  title: PropTypes.string.isRequired,
  setName: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  selectedOptions: PropTypes.string.isRequired,
  controlFunc: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  tabIndex: PropTypes.string.isRequired,
  errorMessage: PropTypes.string,
};

export default RadioGroup;

